export default "__VITE_ASSET__CM2bPZ5$__$_?url__"